/*
 * @Author: Liux
 * @Date: 2020-01-02 07:16:12
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 14:29:17
 */
import { InjectionToken } from '@angular/core';

export const CONFIG_DATA = new InjectionToken<{}>('ALERT_CONFIG_DATA');
